import { isUndefined } from "lodash";

export default function sortBrands(brands, brandIds) {
    if (!isUndefined(brandIds) && brandIds.length > 0) {
        brands.sort(function(a, b){
            return brandIds.indexOf(a.id) - brandIds.indexOf(b.id);
        });
    }
    return brands;
}